<template>
    <v-dialog max-width="600">
        <v-card>
            <v-card-title class="d-flex justify-space-between gc-2 text-wrap">
                {{ title }}
                <v-icon data-cy="close" size="x-small" class="mt-2 ml-auto" @click="emit('close')"> mdi-close </v-icon>
            </v-card-title>
            <v-card-text v-if="text">{{ text }}</v-card-text>
            <v-card-actions>
                <v-btn variant="text" @click="emit('close')">
                    {{ closeBtnText || $t('close') }}
                </v-btn>
                <v-btn variant="flat" color="primary" @click="emit('confirm')">
                    {{ confirmationBtnText || $t('confirm') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
    const props = defineProps<{
        title?: string
        text?: string
        confirmationBtnText?: string
        closeBtnText?: string
    }>()

    const emit = defineEmits<{
        (e: 'confirm' | 'close'): void
    }>()
</script>
